import React from "react";
import KpiSummaryLevelThreeKpiCard from "./KpiSummaryLevelThreeKpiCard";
import PropTypes from "prop-types";

function KpiSummaryLevelThreeKpiLevel1Component(props) {
    return (
        <div style={{ margin: "1% 0%" }}>
            <div
                className="card-header"
                style={{
                    backgroundColor: "#757AF7",
                    color: "#FFFFFF",
                    fontWeight: "bold",
                    borderRadius: "0%",
                }}
            >
                Level 1 kpi&apos;s
            </div>
            <div
                className="card-body"
                style={{
                    border: "solid #757AF7",
                    borderRadius: "0%",
                    padding: "0%",
                    backgroundColor: "#E0E0E0",
                }}
            >
                <div className="row" style={{ padding: "1% 1%" }}>
                    <KpiSummaryLevelThreeKpiCard
                        kpiStatusData={props.kpiStatusData.l1_lateral_acceleration}
                        loading={props.loading}
                        error={props.error}
                        kpiName={"L1 Lateral Acceleration KPI"}
                    />
                    <KpiSummaryLevelThreeKpiCard
                        kpiStatusData={props.kpiStatusData.l1_lateral_jerk}
                        loading={props.loading}
                        error={props.error}
                        kpiName={"L1 Lateral Jerk KPI"}
                    />
                    <KpiSummaryLevelThreeKpiCard
                        kpiStatusData={props.kpiStatusData.l1_longitudinal_acceleration}
                        loading={props.loading}
                        error={props.error}
                        kpiName={"L1 Longitudinal Acceleration KPI"}
                    />
                </div>
                <div className="row" style={{ padding: "1% 1%" }}>
                    <KpiSummaryLevelThreeKpiCard
                        kpiStatusData={props.kpiStatusData.l1_longitudinal_deceleration}
                        loading={props.loading}
                        error={props.error}
                        kpiName={"L1 Longitudinal Deceleration KPI"}
                    />
                    <KpiSummaryLevelThreeKpiCard
                        kpiStatusData={props.kpiStatusData.l1_longitudinal_jerk}
                        loading={props.loading}
                        error={props.error}
                        kpiName={"L1 Longitudinal Jerk KPI"}
                    />
                    <KpiSummaryLevelThreeKpiCard
                        kpiStatusData={props.kpiStatusData.l1_longitudinal_velocity_drop}
                        loading={props.loading}
                        error={props.error}
                        kpiName={"L1 Longitudinal Velocity Drop KPI"}
                    />
                </div>
            </div>
        </div>
    );
}

KpiSummaryLevelThreeKpiLevel1Component.propTypes = {
    loading: PropTypes.bool,
    error: PropTypes.string,
    kpiStatusData: PropTypes.object,
};

export default KpiSummaryLevelThreeKpiLevel1Component;
